import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatInteger,
  NOT_SUPPORT_DOWNLOAD_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import template from './status.pug';

export class StatusColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'Status',
      property: 'RecommendationResult/Status',
      title: i18n.getString('ColumnName_Status'),
      bodyClasses: ['grid-column-status'],
      colClasses: ['col-status'],
    });

    this.i18n = i18n;
  }

  template({
    value: {
      SuccessRecommendationCount,
      TotalRecommendationCount,
      FailedRecommendationCount,
      AdoptionStatus,
      RecommendationType,
    },
  }) {
    return template({
      i18n: this.i18n,
      formatedFailedRecommendationCount: formatInteger(
        TotalRecommendationCount - SuccessRecommendationCount,
        this.i18n
      ),
      formatedSuccessRecommendationCount: formatInteger(SuccessRecommendationCount, this.i18n),
      failedRecommendationCount: TotalRecommendationCount - SuccessRecommendationCount,
      successRecommendationCount: SuccessRecommendationCount,
      downloadable: !_.contains(NOT_SUPPORT_DOWNLOAD_TYPES, RecommendationType)
        && FailedRecommendationCount > 0,
      AdoptionStatus,
    });
  }

  get property() {
    return {
      get: _.identity,
    };
  }
}
